import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Login from "./pages/auth/login";
import Signup from "./pages/auth/signup";
import ForgotPassword from "./pages/auth/forgot_password";
import ResetPassword from "./pages/auth/reset_password";
import RolesList from "./pages/roles-list/roles_list";
import RolesListtest from "./pages/roles-list/roles_preview";
import Navbar from "./components/navbar/navbar";
import ApplicationForm from "./pages/applications/application_form";
import Profile from "./pages/profile/profile2";
import Role from "./pages/roles-list/role";
import PersonalizedRoles from "./pages/roles-list/personalized_roles";
import InProcess from "./pages/interviews/in_process";
import TeamLogin from "./pages/auth/TeamLogin";
import ResourcesHub from "./pages/resources/resources_hub";
import StaleInterviewPopup from "./components/modals/StaleInterviewPopup";
import { useStaleInterviewCheck } from "./hooks/useStaleInterviewCheck";
import RootRedirect from "./components/RootRedirect";
import MentorProfile from "./pages/mentors/MentorProfile";
import { trackPageView } from "./lib/analytics";
import useEngagementTracking from "./hooks/useEngagementTracking";
import MentorsList from "./pages/mentors/MentorsList";
import MenteeProfile from "./pages/mentees/MenteeProfile";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const noNavbarPaths = ["/login", "/signup", "*", "/rolestest", "/team-login", "/forgot-password", "/reset-password", "/mentor", "/mentee"];
  
  // Use the stale interview check hook
  const { showPopup, staleInterviews, handleClosePopup } = useStaleInterviewCheck();

  // Page view + engagement tracking
  React.useEffect(() => {
    // Let the role details page send a richer page view once the role loads
    if (location.pathname === '/role') return;
    trackPageView(location.pathname);
  }, [location.pathname]);

  // Guard guest mentee sessions from navigating elsewhere
  React.useEffect(() => {
    try {
      const isGuestMenteeView = sessionStorage.getItem('guestMenteeView') === 'true';
      const hasToken = !!localStorage.getItem('token');
      if (isGuestMenteeView && !hasToken) {
        const isMenteeRoute = location.pathname.startsWith('/mentee/');
        if (!isMenteeRoute) {
          const fallback = sessionStorage.getItem('guestMenteePath') || '/';
          navigate(fallback, { replace: true });
        }
      }
    } catch (_) {
      // ignore storage errors
    }
  }, [location.pathname, navigate]);
  useEngagementTracking();

  return (
    <div className="App">
      <div className="content bg-gray-100 h-full">
        {!noNavbarPaths.includes(location.pathname) && !location.pathname.startsWith("/mentor/") && !location.pathname.startsWith("/mentee/") && <Navbar />}
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/team-login" element={<TeamLogin />} /> 
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/oldroles" element={<RolesList />} />
           <Route path="/roles" element={<RolesList />} />

           <Route path="/rolesnew" element={<PersonalizedRoles />} />

          <Route path="/rolestest" element={<RolesListtest />} />
          <Route path="/application-form" element={<ApplicationForm />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/role" element={<Role />} />
          <Route path="/interviews" element={<InProcess />} />
          <Route path="/resources" element={<ResourcesHub />} />
          <Route path="/mentor/:mentorName" element={<MentorProfile />} />
           <Route path="/mentors" element={<MentorsList />} />
          <Route path="/mentee/:menteeName" element={<MenteeProfile />} />

        </Routes>
      </div>
      
      {/* Stale Interview Status Popup - Centralized handling */}
      <StaleInterviewPopup
        isOpen={showPopup}
        onClose={handleClosePopup}
        staleInterviews={staleInterviews}
      />

    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
